
export const REACT_APP_API_URL= import.meta.env.REACT_APP_API_URL ?? "";
export const REACT_APP_SENDBIRD_ID= import.meta.env.REACT_APP_SENDBIRD_ID ?? "";
export const REACT_APP_CUSTOMER_PORTAL_URL= import.meta.env.REACT_APP_CUSTOMER_PORTAL_URL ?? "";
export const REACT_APP_CMS_URL= import.meta.env.REACT_APP_CMS_URL ?? "";
export const REACT_APP_SENDBIRD_MODERATOR = import.meta.env.REACT_APP_SENDBIRD_MODERATOR ?? '';
export const REACT_APP_AWS_LAMBDA_API_URL = import.meta.env.REACT_APP_AWS_LAMBDA_API_URL ?? '';